import { create } from 'zustand'

// Debug overlays (in-XR HUD, per-model wireframe boxes, real-world collider wireframes) are off by
// default; the lobby has a toggle. Seed from ?debug for quick links. Read reactively with
// useDebugEnabled() in the scene so flipping the toggle re-renders.
const seedEnabled =
  typeof location !== 'undefined' && new URLSearchParams(location.search).has('debug')

export interface LoadReport {
  status: 'loading' | 'ready' | 'corrupt' | 'error'
  assetId: string
  size?: [number, number, number]
  maxDim?: number
  fit?: number
  error?: string
}

interface DebugState {
  enabled: boolean
  setEnabled(enabled: boolean): void
  reports: Record<string, LoadReport>
  report(instanceId: string, r: Partial<LoadReport> & { status: LoadReport['status'] }): void
  drop(instanceId: string): void
}

export const useDebug = create<DebugState>((set) => ({
  enabled: seedEnabled,
  setEnabled: (enabled) => set({ enabled }),
  reports: {},
  report(instanceId, r) {
    set((s) => ({ reports: { ...s.reports, [instanceId]: { ...s.reports[instanceId], ...r } } }))
  },
  drop(instanceId) {
    set((s) => {
      const next = { ...s.reports }
      delete next[instanceId]
      return { reports: next }
    })
  },
}))

export const useDebugEnabled = () => useDebug((s) => s.enabled)
